import { render } from "./App.vue?vue&type=template&id=12251d3a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=12251d3a&lang=css"
script.render = render

export default script